import { render, staticRenderFns } from "./PeriodofTransaction.vue?vue&type=template&id=6de9864f"
import script from "./PeriodofTransaction.vue?vue&type=script&lang=js"
export * from "./PeriodofTransaction.vue?vue&type=script&lang=js"
import style0 from "./PeriodofTransaction.vue?vue&type=style&index=0&id=6de9864f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports